import React, { useContext, useEffect, useState } from 'react';
import './Navbar.scss';
import { classNameBuilder } from '../../utils/className';
import Logo from '../Logo/Logo';
import { Link, useLocation } from 'react-router-dom';
import {
    CloseIc,
    DefaultAvatar,
    EnterNavbarIcon,
    Favourite2,
    NavSmall,
    NavSmallClose,
} from '../../assets/icons/svgIconsForJSX';
import { ModalViewContext } from '../../context/modalView/ModalViewContext';
import Typography from '../Typography/Typography';
import Button from '../Button/Button';
import { utils } from '../../utils/Utils';
import { GlobalStateContext } from '../../context/globalState/GlobalStateContext';
import { AuthContext } from '../auth/AuthContext';

interface IProps {}

const Navbar: React.FC<IProps> = () => {
    const [close, setClose] = useState(true);
    const cn = classNameBuilder('navbar');
    const location = useLocation();

    const { openModal, closeModal } = useContext(ModalViewContext);
    const { fullSizeHeader } = useContext(GlobalStateContext);

    const { user } = useContext(AuthContext);

    // useEffect(() => {
    //     console.log(fullSizeHeader);
    // }, [fullSizeHeader]);

    const isNavItems = (pathname: string[]) => {
        for (let value of pathname) {
            if (location.pathname.includes(value)) {
                return true;
            }
        }
    };

    const isDark = () => {
        switch (location.pathname) {
            case '/news':
                return true;
            case '/department/1':
                return true;
            case '/vacancies':
                return false;
            case '/vacancies/1':
                return true;
            case '/advantages-conditions':
                return true;
        }
        return (
            location.pathname.includes('/vacancy-detail/') ||
            location.pathname.includes('/internship-detail/') ||
            location.pathname.includes('/news/')
        );
    };
    const navArray = [
        ['/vacancies', 'Вакансии'],
        ['/internships', 'Стажировки'],
        ['/projects', 'Программы развития'],
        ['/education', 'Образование'],
        ['/news', 'Новости'],
        ['/about', 'О нас'],
        ['/contacts', 'Контакты'],
    ];

    const showModalForCookie = () => {
        closeModal();
        openModal({
            variant: 'cookie',
            position: 'right',
            className: cn('cookie-wrap'),
            children: (
                <div className={cn('cookie')}>
                    <div className={cn('cookie-top')}>
                        <Typography className={cn('cookie-top--text')}>
                            Мы используем cookie для персонализации сервисов и&nbsp;удобства
                            пользователей. Вы можете запретить сохранение cookie в&nbsp;настройках
                            своего браузера. <a href={'/policy/USE_COOKIES'}>Подробнее</a>
                        </Typography>
                        <div>
                            <CloseIc className={cn('cookie-top--close-btn')} onClick={closeModal} />
                        </div>
                    </div>

                    <Button
                        scheme={'dark'}
                        onClick={() => {
                            utils.setCookie('isNewActive', 'true', 365);
                            closeModal();
                        }}>
                        Я согласен на передачу файлов cookie
                    </Button>
                </div>
            ),
        });
    };

    useEffect(() => {
        utils.getCookie('isNewActive') === '' && showModalForCookie();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div
            className={cn('', { isDark: isDark(), size: fullSizeHeader ? 'full' : 'normal' })}
            style={{
                display: isNavItems([
                    '/login',
                    '/register',
                    '/reset-password',
                    '/send-password',
                    '/report-error',
                    '/ask-question',
                    '/send-cv',
                    '/restore',
                    '/expired-token',
                    '/confirm-registration',
                    '/block-account',
                ])
                    ? 'none'
                    : 'block',
            }}>
            <div className={cn('container-small')}>
                <div className={cn('nav-small')}>
                    <NavSmall className={cn('icon-small')} onClick={() => setClose(!close)} />
                    <Logo isDark={false} />
                </div>
                {user ? (
                    <div className={cn('nav-small-right')}>
                        {/* <Link
                            to={`/cabinet/${user?.id}/notification`}
                            className={cn('icon-btn-group--notification-small-icon')}>
                            <NotificationNavbarIcon
                                onCheck={location.pathname.includes('notification')}
                            />
                        </Link> */}
                        <Link
                            to={`/cabinet/${user?.id}/favorites`}
                            className={cn('icon-btn-group--favourite-small-icon')}>
                            <Favourite2 onCheck={location.pathname.includes('favorites')} />
                        </Link>
                        <Link
                            to={`cabinet/${user?.id}`}
                            className={cn('icon-btn-group-small--avatar')}>
                            {user.photoAttachment ? (
                                <img
                                    src={`${process.env.REACT_APP_API_URL}/api/v1/attachment/${user.photoAttachment.uid}`}
                                    alt="avatar"
                                />
                            ) : (
                                <DefaultAvatar className={cn('default-small-avatar')} />
                            )}
                        </Link>
                    </div>
                ) : (
                    <Link to={'/login'} className={cn('icon-btn-group--notification-icon')}>
                        <EnterNavbarIcon className={'enter'} useCurrentColor={isDark()} />
                        <div className={cn('icon-btn-group--login')}>Войти</div>
                    </Link>
                )}
                <span
                    onClick={() => setClose(true)}
                    className={cn('background-for-nav', { close: !close })}
                />
                <div className={cn('nav-small-list', { close: close })}>
                    {user ? (
                        <>
                            <Link to={'cabinet'} className={cn('icon-btn-group--avatar')}>
                                <img
                                    src={
                                        user.photoAttachment &&
                                        `${process.env.REACT_APP_API_URL}/api/v1/attachment/${user.photoAttachment.uid}`
                                    }
                                    alt="avatar"
                                />
                            </Link>
                        </>
                    ) : (
                        <Link to={'/login'} className={cn('icon-btn-group--notification-icon')}>
                            <EnterNavbarIcon className={'enter'} useCurrentColor={isDark()} />
                            <div className={cn('icon-btn-group--login')}>Войти</div>
                        </Link>
                    )}
                    {navArray.map((value) => (
                        <a
                            style={{ color: location.pathname.includes(value[0]) ? '#29c178' : '' }}
                            key={'nav-' + value[1]}
                            href={value[0]}>
                            {value[1]}
                        </a>
                    ))}
                    <NavSmallClose onClick={() => setClose(!close)} className={cn('icon-close')} />
                </div>
            </div>
            <div className={cn('container')}>
                <div className={cn('logo-container')}>
                    <Logo isDark={isDark()} />
                </div>
                <div className={cn('routes-container')}>
                    <div className={cn('btn-group')}>
                        {navArray.map((value, index) => (
                            <Link
                                className={cn('btn-item', {
                                    active: location.pathname.includes(value[0]),
                                })}
                                key={'nav-' + index}
                                to={value[0]}>
                                {value[1]}
                            </Link>
                        ))}
                    </div>
                    <div className={cn('icon-btn-group', { isDark: isDark() })}>
                        {user ? (
                            <>
                                {/* <Link
                                    to={`/cabinet/${user?.id}/notification`}
                                    className={cn('icon-btn-group--notification-icon')}>
                                    <NotificationNavbarIcon
                                        onCheck={location.pathname.includes('notification')}
                                    />
                                </Link> */}
                                <Link
                                    to={`/cabinet/${user.id}/favorites`}
                                    className={cn('icon-btn-group--favourite-icon')}>
                                    <Favourite2 onCheck={location.pathname.includes('favorites')} />
                                </Link>
                                <Link
                                    to={`cabinet/${user.id}`}
                                    className={cn('icon-btn-group--avatar')}>
                                    {user.photoAttachment ? (
                                        <img
                                            src={`${process.env.REACT_APP_API_URL}/api/v1/attachment/${user.photoAttachment.uid}`}
                                            alt="avatar"
                                        />
                                    ) : (
                                        <DefaultAvatar className={cn('default-avatar')} />
                                    )}
                                </Link>
                            </>
                        ) : (
                            <Link to={'/login'} className={cn('icon-btn-group--notification-icon')}>
                                <EnterNavbarIcon className={'enter'} useCurrentColor={isDark()} />
                                <div className={cn('icon-btn-group--login')}>Войти</div>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
